import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';

@Injectable()
export class InstallationDistancePluginService extends InspectionPluginService {
  private distancesKeysKeys = [
    { value: 1, label: 'plugins.installationdistance.near' },
    { value: 2, label: 'plugins.installationdistance.far' }
  ];

  private distances = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getDistances() {
    return this.distances;
  }

  public updateDistance(inspectionId: string, pointId: string, pluginId: string, distance: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, distance).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.distances = [];
    this.copyTranslationValues(this.distancesKeysKeys, this.distances, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, distance: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, distance).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
